import type { LocalUserPreferences } from '@cobliteam/api-lib';
import { useFleetCompanyOnboardingStatus, useLocalStorage } from '@cobliteam/hooks';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags/useFeatureFlags';
import { useMemo } from 'react';
import AiRecommendationTasksPopover from '../AiRecommendationTasks/AiRecommendationTasksPopover';
import OnboardingActivationTasksPopover from './Onboarding/OnboardingActivationTasksPopover';
import OngoingActivationTasksPopover from './Ongoing/OngoingActivationTasksPopover';

interface ActivationTasksSwitchProps {
  currentFleetId: string;
}

const ActivationTasksSwitch = ({ currentFleetId }: ActivationTasksSwitchProps) => {
  const { aiRecommendations, ongoingActivationTasks } = useFeatureFlags();

  const [preferences] = useLocalStorage<LocalUserPreferences>('localUserPreferences');
  const { data: onboardingStatus } = useFleetCompanyOnboardingStatus(currentFleetId);

  const shouldShowOngoing = useMemo(() => {
    return ongoingActivationTasks;
  }, [ongoingActivationTasks]);

  const shouldShowOnboarding = useMemo(() => {
    return !shouldShowOngoing && onboardingStatus?.hasAnyOnboardingContract && onboardingStatus?.hasAnyContractSignedInLast90Days && !preferences?.onboardingCompleted;
  }, [shouldShowOngoing, onboardingStatus, preferences?.onboardingCompleted]);

  // Show AI popover in sidebar only when floating card was dismissed
  if (aiRecommendations) return <AiRecommendationTasksPopover />;

  // Fallback to old activation tasks system
  if (shouldShowOngoing) return <OngoingActivationTasksPopover />;
  if (shouldShowOnboarding) return <OnboardingActivationTasksPopover />;

  return null;
};

export default ActivationTasksSwitch;
